export default values => {
  const dateTimeParser = dateTime => {
    let [date, time] = dateTime.split('T')
    date = date.split('-')
    time = time.split(':')

    return {
      date: {
        year: date[0],
        month: date[1],
        day: date[2],
      },
      time: {
        hours: time[0],
        minutes: time[1],
      },
    }
  }

  const { startDateTime, endDateTime } = values.event?.schedule
  const parsedStartDateTime = dateTimeParser(startDateTime)
  const parsedEndDateTime = dateTimeParser(endDateTime)

  const schedule = {
    startDate: parsedStartDateTime.date,
    startTime: parsedStartDateTime.time,
    endDate: parsedEndDateTime.date,
    endTime: parsedEndDateTime.time,
  }

  return {
    ...values,
    event: { ...values.event, schedule },
    media: [values.media],
  }
}
